// タスクS統合 (2026-07-26): 雪系は 11状態の統合プレーン (要素 <model>S、R2 dir は従来の
// <model>Sh) を1本だけ取得し、表示スタイル (j=雨雪判別 / h=大雪 / v=大雨大雪) は
// PNG の PLTE/tRNS を差し替えて出し分ける。差し替えは nowc の実装を流用。
// 状態: 0=域外 1=なし 2..6=雨強度5段 7=みぞれ×雪 8=みぞれ×大雪 9=雪×雪 10=雪×大雪
import { NowcPalette, applyPaletteToPng } from "../nowc/Palette";

export type SnowStyle = "j" | "h" | "v";

type Rgba = [number, number, number, number];

const OUT: Rgba = [255, 255, 255, 16]; // 域外グレー
const NONE: Rgba = [255, 255, 255, 0]; // 降水なし (透明)
const RAIN: Rgba = [51, 102, 255, 255]; // 青
const SLEET: Rgba = [102, 204, 255, 255]; // みぞれ水色
const SNOW: Rgba = [255, 255, 255, 255]; // 雪白
const HEAVY: Rgba = [255, 0, 160, 255]; // 大雪マゼンタ

const STYLE_COLORS: Record<SnowStyle, Rgba[]> = {
    // 雨雪判別 (旧 Sj = PT1 と同色)
    j: [OUT, NONE, RAIN, RAIN, RAIN, RAIN, RAIN, SLEET, SLEET, SNOW, SNOW],
    // 大雪 (旧 Sh = PT2 と同色)
    h: [OUT, NONE, RAIN, RAIN, RAIN, RAIN, RAIN, SNOW, HEAVY, SNOW, HEAVY],
    // 大雨大雪 (旧 Sv = PT3 と同色。雨5段: うす水色/水色/黄/オレンジ/赤)
    v: [
        OUT,
        NONE,
        [153, 204, 255, 255],
        [0, 153, 255, 255],
        [255, 255, 51, 255],
        [255, 153, 0, 255],
        [255, 51, 0, 255],
        SNOW,
        HEAVY,
        SNOW,
        HEAVY,
    ],
};

const SNOW_ELEMENT = /^(GSM|GSA|MSM|LFM)S([jhv])$/;

/** UI 要素名 (GSMSj 等) → スタイル。雪系でなければ null */
export function snowStyleOf(element: string): SnowStyle | null {
    const m = SNOW_ELEMENT.exec(element);
    return m ? (m[2] as SnowStyle) : null;
}

/** UI 要素名 → 統合ストレージ要素名 (GSMS 等)。雪系でなければ null */
export function snowStorageOf(element: string): string | null {
    const m = SNOW_ELEMENT.exec(element);
    return m ? `${m[1]}S` : null;
}

function isPng(data: ArrayBuffer): boolean {
    const b = new Uint8Array(data, 0, Math.min(8, data.byteLength));
    return (
        b.length >= 8 &&
        b[0] === 0x89 &&
        b[1] === 0x50 &&
        b[2] === 0x4e &&
        b[3] === 0x47
    );
}

/** 統合Sタイル (palette PNG) にスタイル別 PLTE/tRNS を適用する。PNG 以外は素通し */
export function applySnowPalette(data: ArrayBuffer, style: SnowStyle): ArrayBuffer {
    if (!isPng(data)) {
        return data;
    }
    const palette = {
        id: "classic",
        label: "",
        colors: STYLE_COLORS[style],
    } as unknown as NowcPalette;
    return applyPaletteToPng(data, palette);
}
